import React from 'react';

const IdRender = ({value}) => {
    return (
        <a href={"/software-attendances/form/" + value}
           className="w-full h-full text-center mt-2 visited:text-zinc-950 hover:text-zinc-950 text-zinc-950">
            {value}
        </a>
);
};

export default IdRender;